import { call,put, select } from "redux-saga/effects";
import { selectCallSessions, setCallSessions } from "../../../state/callSessions/callSessionsSlice";
import { updateActiveCountSaga } from "../updateActiveCallCount/updateActiveCallCount";

export function* addCallSessionSaga({ payload: callSession }) {
    try {
        // Add the new call session to the sessions array
        const currentSessions = yield select(selectCallSessions);
        const updatedSessions = [...currentSessions, callSession];
        yield put(setCallSessions(updatedSessions));
        yield call(updateActiveCountSaga);
    
        console.log('Call session added successfully');
      } catch (error) {
        console.error('Error adding call session:', error);
      }


}